// extracted by mini-css-extract-plugin
export default {"sciencePage":"Ciencia_sciencePage__xfcFB","topSection":"Ciencia_topSection__OETT-"};